import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AlertType = 'success' | 'error' | 'warning' | 'info';

interface AlertState {
    message: string | null;
    type: AlertType | null;
}

const initialState: AlertState = {
    message: null,
    type: null,
};

const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        setAlert: (
            state: AlertState,
            action: PayloadAction<{ message: string; type: AlertType }>
        ) => action.payload,

        clearAlert: (state: AlertState) => initialState,
    },
});

export const { setAlert, clearAlert } = alertSlice.actions;
export default alertSlice.reducer;
